import { ConsultantContractGeneratorType } from "../../consultant-contract-generator-type";
import {
  IConsultantContractStrategy,
  CanSendToOneflowContext,
  GetOneflowTemplateIdContext,
  CanGenerateByOneflowContext,
  CanPreviewContext,
  CanDownloadContext
} from "../consultant-contract-strategy";

export class EmploymentNationalSplitContractStrategy
  implements IConsultantContractStrategy
{
  public readonly name = "EmploymentNationalSplitContractStrategy";

  canPublishToOneflowDirectly(ctx: CanSendToOneflowContext): boolean {
    return ctx.tenant === "wcc";
  }

  canPublishToOneflowViaTicket(ctx: CanSendToOneflowContext): boolean {
    return true;
  }

  getOneflowGeneratorType(ctx: CanGenerateByOneflowContext) {
    return ctx.tenant === "wcc"
      ? ConsultantContractGeneratorType.IntermittentNationalTemplateDataGenerator
      : null;
  }

  getOneflowTemplateId(ctx: GetOneflowTemplateIdContext) {
    if (ctx.env === "dev" || ctx.env === "staging") {
      return ctx.tenant === "wcc"
        ? { workspaceId: "419741", templateId: "11858290" }
        : { workspaceId: "419741", templateId: "2815086" };
    }

    if (ctx.env === "production") {
      return ctx.tenant === "wcc"
        ? { workspaceId: "457689", templateId: "12120547" }
        : { workspaceId: "406174", templateId: "6260936" };
    }

    throw new Error("Unhandled env");
  }

  canDuplicate(): boolean {
    return true;
  }

  canEdit(): boolean {
    return true;
  }

  canPreview(ctx: CanPreviewContext): boolean {
    return ctx.tenant !== "wcc";
  }

  canDownload(ctx: CanDownloadContext): boolean {
    return !!ctx.fileId;
  }

  defaultSalaryChoice(): null {
    return null;
  }
}
